import request from '@/utils/request'
import { getEffectiveCommunityId } from '@/api/community/communityApi'

// 获取投诉类型列表
export function listComplaintTypes(params) {
  return new Promise((resolve, reject) => {
    const communityId = getEffectiveCommunityId(params.communityId)
    request({
      url: '/complaintType.listComplaintType',
      method: 'get',
      params: {
        ...params,
        communityId
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存投诉信息
export function saveComplaint(data) {
  return new Promise((resolve, reject) => {
    const communityId = getEffectiveCommunityId(data.communityId)
    request({
      url: '/complaint.saveComplaint',
      method: 'post',
      data: {
        ...data,
        communityId
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询房间信息
export function queryRooms(params) {
  return new Promise((resolve, reject) => {
    const communityId = getEffectiveCommunityId(params.communityId)
    request({
      url: '/room.queryRoomsByName',
      method: 'get',
      params: {
        ...params,
        communityId
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
